import React from "react";

import { connect } from "react-redux";

import AssessmentGridViewCard from "./AssessmentGridViewCard";
import GridListView from "../../../common/GridListView";
import { selectFlattenAssessmentsData } from "../../../redux/slices/myAssessmentsSlice";

const AssessmentGridView = ({ assessments, onScrollEndReach }) => {
  return (
    <GridListView
      data={['create-job-button', ...assessments]}
      emptyTxt="Looks like there's no assessments added. Try adjusting your filters"
      useImg2={false}
      containerStyle={{ height: "82%" }}
      onLoadMore={onScrollEndReach}
      // containerGridStyle={{ spacing: 2 }}
      itemGridStyles={{ md: 3, xs: 12 }}
      renderItem={(index, id) => (
        <AssessmentGridViewCard index={index} key={id} id={id} />
      )}
    />
  );
};

const mapStateToProps = (state) => ({
  assessments: selectFlattenAssessmentsData(state)
});

export default connect(mapStateToProps)(AssessmentGridView);
